import { UI_COLORS } from '../../utils/colors';

/** Small labeled read-only field; hides itself when the value is empty. */
export const InfoRow = ({ label, value }) => {
  if (value === null || value === undefined || value === '') return null;
  return (
    <div>
      <div className="text-[10px] font-semibold uppercase tracking-wider mb-0.5" style={{ color: UI_COLORS.TEXT.MUTED }}>{label}</div>
      <div className="text-sm font-medium" style={{ color: UI_COLORS.TEXT.PRIMARY }}>{value}</div>
    </div>
  );
};

/** Fixed overlay modal shell used by the portal detail/create modals. */
const PortalModal = ({ isOpen, onClose, title, loading = false, children, footer, maxWidth = 'max-w-3xl' }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: UI_COLORS.BACKGROUNDS.OVERLAY }}>
      <div className={`w-full ${maxWidth} max-h-[90vh] overflow-y-auto rounded-2xl shadow-2xl`} style={{ backgroundColor: UI_COLORS.BACKGROUNDS.CARD }}>
        <div className="flex items-center justify-between px-6 py-4 border-b" style={{ borderColor: UI_COLORS.BORDERS.LIGHT }}>
          <h2 className="text-lg font-bold" style={{ color: UI_COLORS.TEXT.PRIMARY }}>{title}</h2>
          <button type="button" onClick={onClose} className="text-2xl leading-none hover:opacity-70" style={{ color: UI_COLORS.TEXT.MUTED }} aria-label="Close">×</button>
        </div>
        <div className="px-6 py-5">
          {loading ? (
            <div className="flex items-center justify-center py-16">
              <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-t-2" style={{ borderColor: UI_COLORS.BRAND.TERTIARY }} />
            </div>
          ) : children}
        </div>
        {footer && <div className="px-6 py-4 border-t flex justify-end gap-2" style={{ borderColor: UI_COLORS.BORDERS.LIGHT }}>{footer}</div>}
      </div>
    </div>
  );
};

export default PortalModal;
